import { getExceptionFromAxiosError } from '@/client/helpers';
import { AxiosError, AxiosInstance, AxiosResponse } from 'axios';

export interface ImpersonationTokenResponse {
  accessToken: string;
  tokenType: string;
  expiresIn: number;
  refreshToken?: string;
  impersonatedUser: {
    id: string;
    username: string;
    email?: string;
    firstName?: string;
    lastName?: string;
  };
  expiresAt: string;
}

export const impersonationService = (client: AxiosInstance) => {
  const IMPERSONATE_BASE_URL = '/auth/impersonate';

  const startImpersonation = async (
    targetUserId: string,
  ): Promise<ImpersonationTokenResponse> => {
    try {
      const result = await client.post<
        ImpersonationTokenResponse,
        AxiosResponse<ImpersonationTokenResponse>
      >(
        `${IMPERSONATE_BASE_URL}/${targetUserId}`,
        {},
        {
          withCredentials: true,
        },
      );

      return result.data;
    } catch (e) {
      throw getExceptionFromAxiosError(e as AxiosError);
    }
  };

  return {
    startImpersonation,
  };
};
